// UTC, not local time -- must match enrollmentRecapOrderHelpers.ts's
// getDailyKey() (also UTC), since the recap compares this window's
// interactions against that helper's order-membership window. In timezones
// like Tanzania (UTC+3), local midnight is hours away from UTC midnight, so
// using local time here would put interactions and orders on different
// "today" windows and misclassify a source near the day boundary.
export const getStartOfDayTimestamp = (): number => {
    const now = new Date()
    return Math.floor(
        Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()) /
            1000
    )
}
